export const formatDescription = ({ text = '', bulletPoints = [] } = {}) => `${text}<ul>${bulletPoints
    .map((bulletPoint) => `<li>${bulletPoint}</li>`)
    .join('')}</ul>`;
//# sourceMappingURL=utils.js.map